<template>
  <Collapse
    class="tenant-submission-comment-history"
    :expand="false"
    :withBorder="false"
  >
    <div
      slot="title"
      class="comment-title"
    >
      {{ $t('tenantProjects.reviewHistory') }}
    </div>
    <div
      v-if="showPM || histories.length"
      slot="content"
      class="comment-contents"
    >
      <div class="tech-comment-content">
        <div
          v-if="showPM"
          class="title"
        >
          {{ $t('tenantProjects.submission.pm') }}
        </div>
        <div class="tech-comment-history">
          <div
            v-for="rec in histories"
            :key="rec.id"
            class="clearfix history-item"
          >
            <div class="update-history__text">
              {{ rec.createdBy.displayName }}
            </div>
            <div class="update-history__text">
              {{ rec.createdAt | formatDate('DD MMM YY HH:mm') }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </Collapse>
</template>

<script>
import Collapse from '@/controls/Collapse'

export default {
  components: {
    Collapse,
  },
  props: {
    histories: {
      type: Array,
      default: () => ([]),
    },
    showPM: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.tenant-submission-comment-history {
  ::v-deep .title-container {
    border-bottom: 1px solid #e0e0e0;
  }

  .comment-title, .title {
    font-weight: bold;
  }

  .comment-contents {
    margin-top: 10px;
  }

  .desgin-comment-content {
    margin-bottom: 16px;
  }

  .design-comment-history, .tech-comment-history {
    width: 350px;
    .history-item {
      display: flex;
    }
  }

  .update-history__text {
    flex: 1;
    color: #878787;
    font-size: 11px;
    padding-left: 0 10px;
    font-style: italic;
    line-height: 20px;
    p, div {
      margin-bottom: 0;
      text-align: right;
    }
  }
}
</style>
